import React from 'react';
import {Button, Form, Image} from 'semantic-ui-react';
import styles from "./captcha.module.css";

function CaptchaV2(props) {

    const refreshCaptcha = () => {
        props.refreshCaptcha();
    }

    return (
        <div className={styles.captcha}>
            <input className={styles.captchaText}
                value={props.captchaChars}
                   onChange={props.onChangeValue}
                   placeholder="Karakterleri girin"
                   autoComplete="off"
                   maxLength={6}
            />
            <div className={styles.captchaImage}>
                <Image src={`data:image/jpeg;base64,${props.data}`} />
                <Button type="button" className={styles.captchaImageButton} icon='refresh' onClick={refreshCaptcha}/>
            </div>
        </div>
    );
}

export default CaptchaV2;